import * as React from 'react';
import { ArticleHeading5 } from '@cian/ui-kit';

import { IconProductEscrou16, IconProductSalesStart16 } from '@cian/ui-kit-design-tokens/icons';

import * as styles from './styles.css';

interface IHouseTitleProps {
  name: string;
  gray: boolean;
  isEscrow: boolean;
  isSalesStart?: boolean;
}

export function HouseTitle({ name, gray, isEscrow, isSalesStart }: IHouseTitleProps) {
  return (
    <div className={styles['title']} data-testid="HouseTitle">
      <ArticleHeading5 color={gray ? 'gray40_100' : 'text-primary-default'}>{name}</ArticleHeading5>
      <div className={styles['labels']}>
        {isEscrow && <IconProductEscrou16 color="icon-main-default" data-testid="IconEscrou16" />}
        {isSalesStart && (
          <IconProductSalesStart16 color="icon-negative-default" viewBox="-1 -1 18 18" data-testid="IconSalesStart16" />
        )}
      </div>
    </div>
  );
}
